<template>
  <div>
    <recipient-layout v-if="user?.type === 'recipient'">
      <router-view />
    </recipient-layout>
    <template v-else>
      <v-app v-if="showApp">
        <app-navigation-drawer
          v-if="hasNav"
          :drawer="drawer"
          :menu="navMenu"
          :rail="railOn && device.isDesktop"
          :available-languages="availableLanguages"
          @update:drawer="drawer = $event"
          @toggle-rail="toggleRail"
          @set-lang="setLang"
          @logout="logout"
        />
        <app-bar
          v-if="$route.name !== 'canteen' && $route.name !== 'canteen-testing' && $route.name !== 'canteen-v4'"
          :menu="menu"
          :nav-menu="navMenu"
          flat
          :available-languages="availableLanguages"
          :hide-button="!hasNav"
          :rail="railOn"
          @toggle-drawer="onToggleDrawer"
          @open-palette="palette = true"
          @set-lang="setLang"
          @logout="logout"
        />
        <command-palette
          v-if="hasNav || (user.restaurants || []).length > 1"
          v-model="palette"
          :nav-menu="navMenu"
          :rail="railOn"
          :available-languages="availableLanguages"
          @toggle-rail="toggleRail"
          @logout="logout"
        />

        <global-snackbar />
        <v-main :style="$route.name === 'company-menu' && 'background-color: #fff'">
          <v-container fluid class="pa-0">
            <v-row
              :no-gutters="device.isDesktop || !isCanteen"
              :class="isCanteen ? '' : device.isDesktop ? 'pa-0' : ''"
            >
              <v-col cols="12">
                <router-view></router-view>
              </v-col>
            </v-row>
          </v-container>
          <v-btn
            v-if="!isCanteen && fab"
            fab
            color="primary"
            dark
            bottom
            right
            fixed
            @click="toTop"
          >
            <v-icon>mdi-chevron-up</v-icon>
          </v-btn>
        </v-main>
        <app-footer v-if="!isCanteen" />
      </v-app>
      <v-app v-else>
        <router-view></router-view>
      </v-app>
    </template>
    <!--PORUDZBA-->
    <order-notification-snackbar />
  </div>
</template>

<script>
import setLang from "@/mixins/setLang";
import menuItemsMixin from "@/mixins/menuItemsMixin";
import menuMixin from "@/mixins/menuMixin";
import GlobalSnackbar from "@/components/global/GlobalSnackbar.vue";
import RecipientLayout from "@/layouts/RecipientLayout.vue";
import AppFooter from "@/components/layout/AppFooter.vue";
import OrderNotificationSnackbar from "@/components/layout/OrderNotificationSnackbar.vue";
import AppNavigationDrawer from "@/components/layout/AppNavigationDrawer.vue";
import LanguageSelector from "@/components/layout/LanguageSelector.vue";
import AppAvatarMenu from "@/components/layout/AppAvatarMenu.vue";
import AppReportGuestAvatarMenu from "@/components/layout/AppReportGuestAvatarMenu.vue";
import AppLogo from "@/components/layout/AppLogo.vue";
import AppBar from "@/components/layout/AppBar.vue";
import CommandPalette from "@/components/layout/CommandPalette.vue";
import { navState, loadNavPrefs, setRail, pushRecent } from "@/utils/navPrefs";
import { itemKey } from "@/utils/menuGroups";

export default {
  mixins: [setLang, menuItemsMixin, menuMixin],
  components: {
    GlobalSnackbar,
    RecipientLayout,
    AppFooter,
    OrderNotificationSnackbar,
    AppNavigationDrawer,
    LanguageSelector,
    AppAvatarMenu,
    AppReportGuestAvatarMenu,
    AppLogo,
    AppBar,
    CommandPalette,
  },
  data: () => ({
    fab: false,
    drawer: false,
    palette: false,
  }),
  created() {
    this.$root.$on("change-credit-emit", (data) => {
      if (data) {
        const userCredit = this.user?.credit || [];
        const substraction = data === "add" ? -1 : 1;
        if (userCredit.length && userCredit[userCredit.length - 1].duguje) {
          userCredit[userCredit.length - 1].duguje =
            parseFloat(userCredit[userCredit.length - 1].duguje) + substraction;
        }

        this.$forceUpdate();
      }
    });

    this.$root.$on("langChanged", ({ data }) => {
      let lang = data.data.alphabet;
      if (lang == "cir") {
        this.$store.commit("SAVE_LANGUAGE", 1 - 1);
      } else if (lang == "lat") {
        this.$store.commit("SAVE_LANGUAGE", 1 - 0);
      }
    });
  },
  mounted() {
    this.$store.commit("SET_DRAWER", true);
    this.setupScrollListener();
    window.addEventListener("keydown", this.onShellKey);
  },

  beforeDestroy() {
    this.removeScrollListener();
    window.removeEventListener("keydown", this.onShellKey);
  },

  methods: {
    setupScrollListener() {
      this.handleScroll = () => {
        this.fab = window.scrollY > 200;
      };
      window.addEventListener("scroll", this.handleScroll);
    },

    removeScrollListener() {
      if (this.handleScroll) {
        window.removeEventListener("scroll", this.handleScroll);
      }
    },

    // odjava aktivnog naloga — prebacuje na drugi sačuvan nalog ako postoji
    logout() {
      this.$store.dispatch("accounts/signOut");
    },
    toTop() {
      this.$vuetify.goTo(0);
    },
    // Računar: burger sužava/širi meni; tablet i telefon: otvara/zatvara ploču.
    onToggleDrawer() {
      if (this.device.isDesktop) {
        this.toggleRail();
      } else {
        this.drawer = !this.drawer;
      }
    },
    toggleRail() {
      setRail(!this.railOn);
    },
    // Ctrl/Cmd K otvara pretragu svega; "[" sužava meni (osim dok se kuca u polju).
    onShellKey(event) {
      if (!this.showApp) return;
      if ((event.ctrlKey || event.metaKey) && !event.altKey && (event.key === "k" || event.key === "K")) {
        if (this.hasNav || (this.user.restaurants || []).length > 1) {
          event.preventDefault();
          this.palette = !this.palette;
        }
        return;
      }
      if (event.key === "[" && !event.ctrlKey && !event.metaKey && !event.altKey && this.hasNav && this.device.isDesktop) {
        const el = event.target;
        const typing = el && (/^(input|textarea|select)$/i.test(el.tagName) || el.isContentEditable);
        if (!typing) {
          event.preventDefault();
          this.toggleRail();
        }
      }
    },
  },
  computed: {
    showApp() {
      return (
        !!this.user &&
        ![
          "auth-login",
          "auth-forgot-password",
          "auth-reset-password",
          "kitchen-display",
          "kitchen-display-v2",
          "delivery-app-redirect",
        ].includes(this.$route.name)
      );
    },
    // Stavke bočnog menija: firma i kupac imaju svoj `menu`, ostali `customMenu`.
    navMenu() {
      if (!this.user) return [];
      return ["company", "customer"].includes(this.user.type) ? this.menu : this.customMenu;
    },
    // Meni od jedne stavke nema ni ploču ni dugme za meni.
    hasNav() {
      return this.navMenu.length > 1;
    },
    // Sužen meni: izbor korisnika, inače po širini ekrana (ispod 1440 px).
    railOn() {
      return navState.rail !== null ? navState.rail : this.$vuetify.breakpoint.width < 1440;
    },
    isCanteen() {
      return ["canteen", "naplata2", "canteen-testing", "canteen-v4"].includes(this.$route.name);
    },
    site() {
      return this.$store.state.selectedRestaurant;
    },
    user() {
      return this.$store.state.user.user;
    },
    availableLanguages() {
      const restaurant = this.restaurant || this.company?.restaurant;
      const allLanguages = this.getAvailableLanguages();

      let allowedCodes = [];

      if (restaurant?.id === 1) {
        const allResLangs = (this.company?.restaurants || []).flatMap(
          (res) => res.settings?.language || []
        );
        allowedCodes = [...new Set(allResLangs)];
      } else {
        allowedCodes = restaurant?.settings?.language || [];
      }

      if (allowedCodes.length === 0) {
        return allLanguages;
      }

      const uniqueAllowedCodes = new Set(allowedCodes);
      return allLanguages.filter((lang) => uniqueAllowedCodes.has(lang.code));
    },
    company() {
      return this.$store.state.company;
    },
    restaurant() {
      return this.$store.state.restaurant;
    },
  },
  watch: {
    "user.id": {
      handler(id) {
        loadNavPrefs(id);
      },
      immediate: true,
    },
    // Nedavno posjećene stranice (za "Nedavno" u meniju i u pretrazi)
    "$route.fullPath"() {
      const hit = this.navMenu.find((item) => {
        const to = item.to || {};
        return (to.name && this.$route.name === to.name) || (to.path && this.$route.path === to.path);
      });
      if (hit) pushRecent(itemKey(hit));
    },
    availableLanguages: {
      handler(newLanguages) {
        if (newLanguages.length === 0) return;

        // No restaurant/company context (e.g. logged out, on the login
        // page) — don't touch the locale, keep whatever was last used.
        if (!this.restaurant && !this.company) return;

        // A user's own saved choice (LanguageSelector, restorani-lang in
        // localStorage) must survive a plain page refresh - this handler
        // also fires immediately on every fresh app load, so without this
        // check it silently overwrote that choice back to the restaurant
        // default every time (reported 16.09: pick Latinica, refresh,
        // back to ćirilica). Only honor it when this restaurant/company
        // actually supports it - otherwise fall through to the default.
        const storedLang = localStorage.getItem("restorani-lang");
        if (storedLang && newLanguages.some((lang) => lang.code === storedLang)) {
          this.$i18n.locale = storedLang;
          return;
        }

        const restaurant = this.restaurant || this.company?.restaurant;
        const restaurantDefault =
          restaurant?.id === 1
            ? this.company?.restaurants?.[0]?.settings?.language?.[0]
            : restaurant?.settings?.language?.[0];

        // Default to the restaurant's first configured language (falling
        // back to the first available one) so switching to a
        // restaurant/company without Cyrillic support never keeps a
        // stale locale from a previous session around.
        const locale = restaurantDefault || newLanguages[0].code;

        this.$i18n.locale = locale;
        this.setLang();
      },
      immediate: true,
    },
    "$store.state.user.user"() {
      if (!this.$store.state.user.user?.id) {
        this.$router.push({ name: "auth-login" }).then(() => {
          window.location.reload();
        });
      }
    },
    restaurant() {
      // Check if we need to redirect to home for restaurants
      const customersRestaurantIndex = this.computedItems.findIndex(
        (item) => item.title === "Корисници изабраног ресторана"
      );

      if (customersRestaurantIndex > -1) {
        this.$router.push({ name: "company-menu" });
      }
    },
  },
};
</script>

<style>
/* Global font family override */
* {
  font-family: "IBM Plex Sans", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    sans-serif !important;
}

.v-application {
  font-family: "IBM Plex Sans", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    sans-serif !important;
}

.v-application .text-h1,
.v-application .text-h2,
.v-application .text-h3,
.v-application .text-h4,
.v-application .text-h5,
.v-application .text-h6,
.v-application .headline,
.v-application .title,
.v-application .subtitle-1,
.v-application .subtitle-2,
.v-application .body-1,
.v-application .body-2,
.v-application .caption,
.v-application .overline,
.v-btn,
.v-card,
.v-list,
.v-toolbar,
.v-navigation-drawer {
  font-family: "IBM Plex Sans", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    sans-serif !important;
}
</style>
